import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface Step {
  title: string;
  description: ReactNode;
}

interface StepListProps {
  steps: Step[];
  className?: string;
}

const StepList = ({ steps, className }: StepListProps) => {
  return (
    <ol className={cn("space-y-4", className)}>
      {steps.map((step, index) => (
        <li key={index} className="flex gap-4">
          <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-semibold text-primary">
            {index + 1}
          </div>
          <div className="flex-1 pt-0.5">
            <h4 className="mb-1 font-medium text-foreground">{step.title}</h4>
            <div className="text-sm text-muted-foreground">{step.description}</div>
          </div>
        </li>
      ))}
    </ol>
  );
};

export default StepList;
